import { IoSearchOutline } from "react-icons/io5";
import { useState, useEffect } from "react";

const TextboxSearch = ({ onSearch, width = "w-full md:w-96", ...rest }) => {
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      if (typeof onSearch === "undefined") return null;

      onSearch(searchQuery);
    }, 750);

    return () => clearTimeout(debounceSearch);
  }, [searchQuery, onSearch]);

  return (
    <div className="relative">
      <input
        type="text"
        className={`form-control pl-9 ${width}`}
        onChange={(e) => setSearchQuery(e.target.value)}
        {...rest}
      />
      <div className="absolute top-1 mt-0.5 ml-2 pt-1">
        <IoSearchOutline className="text-gray-300 ml-1" />
      </div>
    </div>
  );
};

export default TextboxSearch;
